export default __webpack_public_path__ + "static/media/big-time-planet.7684255b.png";